module.exports = __webpack_public_path__ + "static/img/knives21.3e0fa99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives21.jpg
// module id = zCUO
// module chunks = 0